<template>
  <div :class="[$style.card, { [$style['card--active']]: isActive }]">
    <!-- prettier-ignore -->
    <div :class="$style.card__actions" v-if="!!$slots.actions"><slot name="actions" /></div>
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    isActive?: boolean
  }>(),
  { isActive: false }
)
</script>

<style module lang="scss">
.card {
  position: relative;
  border-radius: 4px;
  padding: 8px 12px;
  border: 1px solid $color-border-low-emphasis;
  color: $color-text-and-object-high-emphasis;
  background-color: $color-surface-primary;

  &--active {
    border: 1px solid transparent;
    color: $color-text-and-object-high-emphasis-inverse;
    background-color: $color-surface-accent-primary;
  }

  &__actions {
    position: absolute;
    top: 8px;
    right: 12px;
  }
}
</style>
